module.exports = __webpack_public_path__ + "static/media/carnet_frente.135716b3.JPG";